/**
 * Legacy Facade
 *
 * Exposes functions to the window object for backward compatibility with PHP templates.
 * This allows the new TypeScript code to be called from inline scripts in PHP views.
 *
 * Only functions that are CALLED FROM PHP TEMPLATES (outside src/frontend) are exposed here.
 * Internal JavaScript functions that call other JavaScript functions do NOT need to be here.
 */

import { ratingService } from '../services/RatingService';
import { AppState, appState } from '../state/AppState';
import { Cell, Grid, Puzzle, HistoryManager, Settings } from '../core';
import { CellEvents, domToCellId, cellIdToDom } from '../events/CellEvents';
import { MainMenu, SolutionMenu, ClueMenu } from '../ui';

// Import from sub-modules (also re-exported below)
import {
    passwordStrength,
    checkPassword,
    showOrHide,
    selectAllCheckboxes,
} from './passwordUtils';
import { savePuzzle } from './saveWarning';
import { historyJump, jumpToCell, setExpression } from './navigation';
import { searchExpression } from './search';
import { initPuzzleBuilder, initPuzzleSolver } from './puzzleInit';

// Re-export public API
export {
    passwordStrength,
    checkPassword,
    showOrHide,
    selectAllCheckboxes,
    savePuzzle,
    historyJump,
    jumpToCell,
    setExpression,
    searchExpression,
    initPuzzleBuilder,
    initPuzzleSolver,
};

/**
 * Expose all legacy functions to the window object.
 * Call this once on application initialization.
 */
export function exposeLegacyFacade(): void {
    // Password functions (profil.php, regisztracio.php)
    window.jelszoErosseg = passwordStrength;
    window.checkJelszo = checkPassword;

    // Show/Hide toggle (solver, builder, puzzles list pages)
    window.showOrHide = showOrHide;

    // Checkbox utility (rejtveny.php)
    window.allCheckbox = selectAllCheckboxes;

    // Puzzle initialization (rejtvenyepito.php, rejtvenyfejto.php)
    window.initRejtvenyEpito = initPuzzleBuilder;
    window.initRejtvenyFejto = initPuzzleSolver;

    // Search (SearchController.php)
    window.keresKifejezes = searchExpression;

    // History jump (used by history bar links)
    window.elozmenyUgras = historyJump;

    // Cell jump (used by clue column links)
    window.ugrasMezore = jumpToCell;

    // Expression restore (used by clue menu "Megváltozott kifejezés" links)
    window.setKifejezes = setExpression;

    // Expose TypeScript classes for gradual migration
    // These allow legacy code to use new TS implementations
    window.PuzzleBuilder = {
        // Core classes
        AppState,
        appState,
        Cell,
        Grid,
        Puzzle,
        HistoryManager,
        Settings,
        // Event handlers
        CellEvents,
        domToCellId,
        cellIdToDom,
        // UI components
        MainMenu,
        SolutionMenu,
        ClueMenu,
    };

    // Auto-initialize rating components (replaces AJAX.initErtekeles)
    ratingService.autoInit();

    console.log('Legacy facade initialized');
}
